import authService from './services/authService';
import { setupApiLogging } from './services/apiLogger';

const BASE_URL = `${process.env.REACT_APP_API_URL}`;

export const publicRequest = setupApiLogging(authService.createAxiosInstance());

export const userRequest = setupApiLogging(authService.createAxiosInstance());

// Legacy function for backward compatibility
export const updateAuthToken = (token) => {
    console.warn('updateAuthToken is deprecated. Use authService instead.');
};